/**
 * Composed Chart  component events
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { termsEditor } from "../../terms";

export const ComponentComposedChart_Events = {
	zoomChanged: {
		...termsEditor.schemas.composedChart.events.zoomChanged,
		icon: "mdi/magnify"		
	}
	/*dataPointClick: {
		...termsEditor.schemas.composedChart.events.dataPointClick,
		icon: "mdi/gesture-tap"
	},*/
	/*rangeChange: {
		...termsEditor.schemas.composedChart.events.rangeChange,
	}*/
};
